<template>
    <b-container fluid>
        <div>
            <b-card>
                <b-row>
                    <b-col>
                        <app-assign-operational-user-filters ref="operationalUserFilters" @filter="onFilter" @clear="onClear"></app-assign-operational-user-filters>
                    </b-col>
                </b-row>
            </b-card>
            <b-row class="mt-3">
                <b-col>
                    <app-assign-operational-users-List :evaluation-id="evaluationId" :administratives="administratives" :on-change-page="onChangePage" :table-data="securityGuards"></app-assign-operational-users-List>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import appAssignOperationalUsersList from './AssignOperationalUsersList'
import appAssignOperationalUserFilters from './AssignOperationalUsersFilters'
export default {
    components: {
        appAssignOperationalUsersList,
        appAssignOperationalUserFilters
    },
    props: {
        evalId: {
            type: Number,
        },
    },
    data: () => ({
        page: 1,
        securityGuards: [],
        administratives: [],
        evaluationId: 0,
        filters: '',
        sortDir: 'asc',
        sortBy: 'name',
    }),
    methods: {
        async loadSecurityGuards(){
                const params = {
                    ...this.filters,
                    page: this.page,
                    sortBy: this.sortBy,
                    sortDir: this.sortDir,
                    administrative: true
                }
            const { data } = await repo.get(`users/security-guards`, params)
            this.securityGuards = data
        },
        async loadAdministratives(){
            const {data} = await repo.get('users/administratives',{
                account_executive: true
            })
            this.administratives = data
        },
        onChangePage(page) {
            this.page = page
            this.administratives = []
            this.loadAdministratives()
            this.loadSecurityGuards()
        },
        onFilter(filters){
            this.filters = filters
            this.page = 1
            this.loadAdministratives()
            this.loadSecurityGuards()
        },
        onClear(){
            this.page = 1
            this.administratives = []
            this.loadAdministratives()
            this.loadSecurityGuards()
        }
    },
    mounted(){
        this.loadSecurityGuards()
        this.loadAdministratives()
    }
}
</script>
